import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

// Single source of truth for the app CTA's attention animation.
// Change the keyframes here to restyle the effect everywhere.
const pulse = keyframes`
	0% {
		box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.5);
	}
	70% {
		box-shadow: 0 0 0 12px rgba(33, 150, 243, 0);
	}
	100% {
		box-shadow: 0 0 0 0 rgba(33, 150, 243, 0);
	}
`;

export const AnimatedButton = styled(Button)(() => ({
	textTransform: 'none',
	fontWeight: 600,
	animation: `${pulse} 2s ease-in-out infinite`,
	willChange: 'box-shadow',
	'&:hover': {
		animation: 'none',
	},
	'@media (prefers-reduced-motion: reduce)': {
		animation: 'none',
	},
}));
